import React from 'react';
import styled from 'styled-components';
import { Icon } from './Icon';

interface Props {
	icon?: boolean;
	children: React.ReactNode;
}

const Wrapper = styled.div`
	width: 100%;
	text-align: center;
	font-size: 3.25rem;
	margin-top: 0.75em;
	margin-bottom: 0.5em;
`;

const Title = styled.h1`
	margin-top: 0;
	margin-bottom: 0;
	font-size: 3.25rem;
	text-align: center;
`;

const IconWrapper = styled.div`
	min-height: 0.5em;
	font-size: 3.25rem;
`;

export const PageHeader: React.FC<Props> = (props: Props) => {
	let icon: React.ReactNode | null = null;
	if (props.icon) {
		icon = <Icon name="medium--sims" />
	}
	return (
		<Wrapper>
			<IconWrapper>{icon}</IconWrapper>
			<Title>
				{props.children}
			</Title>
		</Wrapper>
	)
};